import { Service, NewService } from '../../models/Entities/Service';
import { AppThunkAction } from '../reducers';
import { ErrorType } from '../../models/HttpError';

// services
import * as Services from '../../services/Service.Services';

// Actions
import * as Actions from '../actions/Service.Actions';

type KnownAction =
  | Actions.ServiceGetAll_Request_Action
  | Actions.ServiceGetAll_Receive_Action
  | Actions.ServiceGetAll_Fail_Action
  | Actions.ServiceUpdateAll_Request_Action
  | Actions.ServiceUpdateAll_Receive_Action
  | Actions.ServiceUpdateAll_Fail_Action
  | Actions.ServiceGetById_Request_Action
  | Actions.ServiceGetById_Receive_Action
  | Actions.ServiceGetById_Fail_Action
  | Actions.ServiceGetByConsumerId_Request_Action
  | Actions.ServiceGetByConsumerId_Receive_Action
  | Actions.ServiceGetByConsumerId_Fail_Action
  | Actions.ServiceAdd_Request_Action
  | Actions.ServiceAdd_Receive_Action
  | Actions.ServiceAdd_Fail_Action
  | Actions.ServiceUpdate_Request_Action
  | Actions.ServiceUpdate_Receive_Action
  | Actions.ServiceUpdate_Fail_Action
  | Actions.ServiceDelete_Request_Action
  | Actions.ServiceDelete_Receive_Action
  | Actions.ServiceDelete_Fail_Action;

export const actionCreators = {
  GetAllServices: (): AppThunkAction<KnownAction> => async (dispatch, getState) => {
    const state = getState();

    if (state.Services?.isLoadingAll || state.Services?.successLoadingAll) return;

    if (!state.Services?.successLoadingAll) {
      dispatch({
        type: 'SERVICE_GET_ALL_REQUEST_ACTION'
      });

      Services.GetAllServices()
        .then((services: Service[]) => {
          dispatch({
            type: 'SERVICE_GET_ALL_RECEIVE_ACTION',
            Services: services
          });
        })
        .catch((error: ErrorType) =>
          dispatch({
            type: 'SERVICE_GET_ALL_FAIL_ACTION',
            error: error
          })
        );
    } else {
      dispatch({
        type: 'SERVICE_UPDATE_ALL_REQUEST_ACTION'
      });

      Services.GetAllServices()
        .then((services: Service[]) => {
          dispatch({
            type: 'SERVICE_UPDATE_ALL_RECEIVE_ACTION',
            Services: services
          });
        })
        .catch((error: ErrorType) =>
          dispatch({
            type: 'SERVICE_UPDATE_ALL_FAIL_ACTION',
            error: error
          })
        );
    }
  },

  GetServiceById:
    (serviceId: string): AppThunkAction<KnownAction> =>
    async (dispatch) => {
      dispatch({
        type: 'SERVICE_GET_BY_ID_REQUEST_ACTION',
        ServiceId: serviceId
      });

      Services.GetServiceById(serviceId)
        .then((service: Service) => {
          dispatch({
            type: 'SERVICE_GET_BY_ID_RECEIVE_ACTION',
            Service: service
          });
        })
        .catch((error: ErrorType) =>
          dispatch({
            type: 'SERVICE_GET_BY_ID_FAIL_ACTION',
            error: error
          })
        );
    },

  GetServicesByConsumerId:
    (consumerId: string): AppThunkAction<KnownAction> =>
    async (dispatch) => {
      dispatch({
        type: 'SERVICE_GET_BY_CONSUMER_ID_REQUEST_ACTION',
        ConsumerId: consumerId
      });

      Services.GetServicesByConsumerId(consumerId)
        .then((services: Service[]) => {
          dispatch({
            type: 'SERVICE_GET_BY_CONSUMER_ID_RECEIVE_ACTION',
            Services: services
          });
        })
        .catch((error: ErrorType) =>
          dispatch({
            type: 'SERVICE_GET_BY_CONSUMER_ID_FAIL_ACTION',
            error: error
          })
        );
    },

  AddService:
    (newService: NewService): AppThunkAction<KnownAction> =>
    async (dispatch) => {
      dispatch({
        type: 'SERVICE_ADD_REQUEST_ACTION',
        NewService: newService
      });

      Services.CreateService(newService)
        .then((service: Service) => {
          dispatch({
            type: 'SERVICE_ADD_RECEIVE_ACTION',
            Service: service
          });
        })
        .catch((error: ErrorType) =>
          dispatch({
            type: 'SERVICE_ADD_FAIL_ACTION',
            error: error
          })
        );
    },

  UpdateService:
    (service: Service): AppThunkAction<KnownAction> =>
    async (dispatch) => {
      dispatch({
        type: 'SERVICE_UPDATE_REQUEST_ACTION',
        Service: service
      });

      Services.UpdateService(service.id, service)
        .then((updatedService: Service) => {
          dispatch({
            type: 'SERVICE_UPDATE_RECEIVE_ACTION',
            Service: updatedService
          });
        })
        .catch((error: ErrorType) =>
          dispatch({
            type: 'SERVICE_UPDATE_FAIL_ACTION',
            error: error
          })
        );
    },

  DeleteService:
    (serviceId: string): AppThunkAction<KnownAction> =>
    async (dispatch) => {
      dispatch({
        type: 'SERVICE_DELETE_REQUEST_ACTION',
        ServiceId: serviceId
      });

      Services.DeleteService(serviceId)
        .then(() => {
          dispatch({
            type: 'SERVICE_DELETE_RECEIVE_ACTION',
            ServiceId: serviceId
          });
        })
        .catch((error: ErrorType) =>
          dispatch({
            type: 'SERVICE_DELETE_FAIL_ACTION',
            error: error
          })
        );
    }
};
